<template>
  <div :class="$style.titleMessage">
    <div
      :class="$style.wrapper"
    >
      <VsIcon
        v-if="showIcon"
        icon="md:warning"
        class="mr-3 mt-1 mt-md-0"
      />
      <div
        :class="$style.textContent"
        class="text-left"
      >
        <slot name="title">
          {{ $t('warn-rated-content') }}
        </slot>
        <slot name="message" />
      </div>
    </div>
  </div>
</template>

<script>
import VsIcon from '@/scripts/Components/Molecules/VsIcon';

export default {
  i18n: {
    en: {
      'warn-rated-content': 'This film contains content that may be inappropriate for some users.',
    },
    zh: {
      'warn-rated-content': '這短片的內容可能不適合一些觀眾。',
    },
    id: {
      'warn-rated-content': 'Film ini mungkin berisi konten yang tidak sesuai untuk beberapa penonton.',
    },
  },
  components: {
    VsIcon,
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" module>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.titleMessage {
  @extend .flex-center;
  padding-left: 24px;
  padding-right: 24px;
}
.wrapper {
  @extend .flex-center;
  max-width: 360px;
}
.textContent {
  line-height: 1.25em;
}

.titleMessage :global(.vs-icon) {
  font-size: 36px;
}
</style>
